/*
 * @Author: Admni
 * @Description: 
 * @Date: 2020-12-24 16:46:24
 * @LastEditTime: 2021-02-26 14:17:42
 */
import axios from 'axios'
import {
  MessageBox,
  Message,
  Notification
} from 'element-ui'
import store from '@/store'
import {
  getToken
} from '@/utils/auth'

let messageInstance = null;

// let baseURL = 'http://192.168.10.48:8000'
// let baseURL = 'http://stage-chat.bestcaco.com/'
// let baseURL = 'https://chat-manager.bestcaco.com/cus'

// let baseURL = '/api'
let baseURL = ''
if (process.env.NODE_ENV === 'development') {
  // 开发环境
  baseURL = 'https://chat-manager.bestcaco.com/cus'
} else if (process.env.NODE_ENV === 'production') {
  // 正式环境
  baseURL = 'https://chat-xpro.bestcaco.com/cus'
}

const service = axios.create({
  // baseURL: '/api',
  baseURL,
  timeout: 20 * 1000
})

// request
service.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['at'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response
service.interceptors.response.use(
  response => {
    const res = response.data
    return res
  },
  error => {
    // if (messageInstance) {
    //   messageInstance.close();
    // }
    // todo: 状态错误码

    if (noticeInstance) {
      noticeInstance.close();
    }

    // messageInstance = Message({
    //   message: error.message,
    //   type: 'error',
    //   duration: 5 * 1000
    // })
    let noticeInstance = Notification.error({
      title: '请求错误',
      message: error.message
    })

    if (error.response && error.response.status === 401) {
      store.dispatch('user/logout').then(() => {
        setTimeout(() => {
          location.reload()
        }, 1000)
      })
    }

    return Promise.reject(error)
  }
)

export default service